import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createToggleSelectedRecordCheckAction, isRecordChecked } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { FrameAttributeSharedProps } from "../../../types";
import { RoleUserRowComponent, RoleUserRowComponentProps } from "../RoleUserRowComponent";

export type RoleUserRowProps = FrameAttributeSharedProps & {
    /** Identifikace uživatele role. */
    id: string;
};

type StateProps = Pick<RoleUserRowComponentProps, "isChecked">;

const mapStateToProps: MapStateToProps<StateProps, RoleUserRowProps, IAppState> = (
    state,
    { dataSourceKey, id },
) => ({
    isChecked: isRecordChecked(state, { dataSourceKey, recordId: id }),
});

type DispatchProps = Pick<
    RoleUserRowComponentProps,
    | "toggleChecked"
>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, RoleUserRowProps> = (
    dispatch,
    { dataSourceKey, recordId, id },
) => ({
    toggleChecked: () => {
        dispatch(createToggleSelectedRecordCheckAction(dataSourceKey, id, recordId));
    },
});

export const RoleUserRow = connect(mapStateToProps, mapDispatchToProps)(RoleUserRowComponent);
